/** @format */

import { useEffect } from 'react';
import Page from 'src/components/Page';
import { WidgetGrid } from '../../components';
import useAuth from 'src/hooks/useAuth';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'src/store';
import { setUserData } from 'src/slices/users';
import {
  markLanguageEventTracked,
  shouldTrackLanguageEvent
} from 'src/analytics/languageDataLayer';

const HomeView = () => {
  const { user, error } = useAuth();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { widgetInfo } = useSelector(state => state.users);
  const { userData } = useSelector(state => state.users);

  useEffect(() => {
    if (user && Object.keys(user).length > 0 && ((userData && Object.keys(userData).length === 0) || !userData)) {
      dispatch(setUserData({ ...user }));
    }
  }, [user, dispatch, i18n.language, widgetInfo]);

  /**
   * Tracks the dashboard language once per tab session in dataLayer.
   * Skips when URL has `language` (handled as `language_changed` in App) or when already tracked.
   */
  useEffect(() => {
    const url = new URL(window.location.href);
    if (
      !url.searchParams.has('language') &&
      shouldTrackLanguageEvent() &&
      window.trackDataLayer
    ) {
      window.trackDataLayer('language', { language: i18n.language });
      markLanguageEventTracked();
    }
  }, [i18n.language]);

  if (error) {
    return (
      <Page className={`dashboard`} title={t('dashboard.title')}>
        <div className="container dashboard__error">
          <p>{error.message || t('errorpage.text')}</p>
        </div>
      </Page>
    );
  }

  return (
    <Page className={`dashboard`} title={t('dashboard.title')}>
      <WidgetGrid />
    </Page>
  );
};

export default HomeView;
